import { SET_FIRE_SET_CONTRACT_PARTIES } from "../actions/Book/actions";
import { SET_CONTRACT_PARTIES } from "../actions/Book/actions";
import { SET_FIRE_SET_BOOK } from "../actions/Book/actions";


const initialState = {
    _fireSetContractParties: false,
    _contractParties: null,
    _fireSetBook: false,
};

const bookReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONTRACT_PARTIES:
            return {
                ...state,
                _contractParties: action.payload.parties,
                _fireSetContractParties: action.payload.fireSet,
            };
        case SET_FIRE_SET_CONTRACT_PARTIES:
            return {
                ...state,
                _fireSetContractParties: action.payload
            };
        case SET_FIRE_SET_BOOK:
            return {
                ...state,
                _fireSetBook: action.payload
            };
        default:
            return state;
    }
};



export default bookReducer;